import { Card, CardContent, Typography } from '@mui/material';
import { format } from 'date-fns';
import React, { FunctionComponent } from 'react';

import { Milestone } from '../../../../apollo/__generated__/graphql';

interface MilestoneCardProps {
  currentMilestone: Milestone | null;
  nextMilestone: Milestone | null;
}

export const MilestoneCard: FunctionComponent<MilestoneCardProps> = ({
  currentMilestone,
  nextMilestone,
}) => {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Typography variant="h6">
          {currentMilestone ? 'Palier actuel' : 'Aucun palier en cours'}
        </Typography>
        <Typography variant="body1">
          {currentMilestone
            ? `Le palier actuel est valable jusqu'au ${format(currentMilestone.endAt, 'dd/MM/yyyy HH:mm')}`
            : nextMilestone
              ? `Le prochain palier démarre le ${format(nextMilestone.startAt, 'dd/MM/yyyy HH:mm')}`
              : "Il n'y a plus de paliers prévus"}
        </Typography>
        {currentMilestone ? (
          <>
            {currentMilestone.prices.length > 1 ? (
              [...currentMilestone.prices].reverse().map((price) => (
                <Typography key={price.day} variant="body2">
                  Prix pour {price.day + 1} soir{price.day + 1 === 1 ? '' : 's'}
                  : {price.value / 100}€
                </Typography>
              ))
            ) : (
              <Typography variant="body2">
                Prix : {currentMilestone.prices[0].value / 100}€
              </Typography>
            )}
            {currentMilestone.bedroomValue ? (
              <Typography variant="body2">
                Supplément chambre : + {currentMilestone.bedroomValue / 100}€
              </Typography>
            ) : null}
            {currentMilestone.noAlcoholDiscount ? (
              <Typography variant="body2">
                Réduction Bacchus Troué : -{' '}
                {currentMilestone.noAlcoholDiscount / 100}€
              </Typography>
            ) : null}
            {currentMilestone.isVoucherOnly ? (
              <Typography variant="body2" color="red">
                {
                  "Ce palier est réservé aux troyens munis d'un code de réduction"
                }
              </Typography>
            ) : null}
          </>
        ) : null}
      </CardContent>
    </Card>
  );
};
